module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av467-24b22a4420c4576713151413e2913bb5.jpg";